import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getFeaturedEvents } from '../services/eventService';
import { useAuth } from '../context/AuthContext';
import { useGeolocation } from '../hooks/useGeolocation';
import { Event } from '../types';
import HeroSearch from '../components/HeroSearch';
import EventsSection from '../components/EventsSection';
import CategoryGrid from '../components/CategoryGrid';

interface HomePageProps {
  searchRef: React.RefObject<HTMLInputElement>;
}

const HomePage: React.FC<HomePageProps> = ({ searchRef }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { city: geoCity } = useGeolocation();
  const [cityEvents, setCityEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);

  // Use either user's city or geolocation city
  const currentCity = user?.city || geoCity;

  useEffect(() => {
    const loadCityEvents = async () => {
      try {
        setLoading(true);
        const events = await getFeaturedEvents(currentCity);
        setCityEvents(events);
      } catch (error) {
        console.error('Error loading city events:', error);
      } finally {
        setLoading(false);
      }
    };

    if (currentCity) {
      loadCityEvents();
    }
  }, [currentCity]);

  return (
    <div className="min-h-screen bg-white">
      <HeroSearch searchRef={searchRef} />

      <EventsSection
        events={cityEvents}
        loading={loading}
        city={currentCity}
      />

      <CategoryGrid />
    </div>
  );
};

export default HomePage;